import { render, staticRenderFns } from "./productNameQuery.vue?vue&type=template&id=60a5162a"
import script from "./productNameQuery.vue?vue&type=script&lang=js"
export * from "./productNameQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports